import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { Form, Row, Col, Button } from "react-bootstrap";
import { NotificationManager } from 'react-notifications';
import { getPageContent } from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

const ContactForm = ({ onSubmit }) => {
  const {hostLanguage} = useLangContext();
  const [contentDetails,setContentDetails] = useState();

  const [isSubmit, setIsSubmit] = useState(false);

  const getAllPageContent = async() => {
    try
    {
      let apiRes = await  getPageContent(hostLanguage, "contact_form");
      let responseData = await apiRes.json();
      if(responseData.res)
      {
        setContentDetails(responseData.data);
      }
      else
      {
        NotificationManager.error(responseData.msg,'',2000);
      }
    }
    catch(error)
    {
      console.error(error);
    }
  }

  // Validation schemas
  const schemaGer = yup.object().shape({
    companyname: yup.string().required("Firmenname ist erforderlich"),
    name: yup
      .string()
      .required("Name ist erforderlich")
      .matches(/^[A-Za-z\s.'-]+$/, "Geben Sie einen gültigen Namen ein"),
    email: yup
      .string()
      .required("E-Mail ist erforderlich")
      .matches(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        "Ungültige E-Mail-Adresse!"
      ),
    phonenumber: yup
      .string()
      .required("Telefonnummer ist erforderlich")
      .min(10, "Die Telefonnummer muss mindestens 10 Ziffern haben")
      .max(20, "Die Telefonnummer darf nicht länger als 20 Ziffern sein"),
    message: yup.string().required("Nachricht ist erforderlich"),
  });

  const schemaEn = yup.object().shape({
    companyname: yup.string().required("Company Name is required"),
    name: yup
      .string()
      .required("Name is required")
      .matches(/^[A-Za-z\s.'-]+$/, "Enter a valid name"),
    email: yup
      .string()
      .required("Email is required")
      .matches(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        "Invalid email address!"
      ),
    phonenumber: yup
      .string()
      .required("Phone Number is required")
      .min(10, "Phone Number must be at least 10 digits")
      .max(20, "Phone Number must not exceed 20 digits"),
    message: yup.string().required("Message is required"),
  });

  const handleSubmit = async (values, formikHelpers) => {
    setIsSubmit(true);
    try {
      await onSubmit(values, formikHelpers);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmit(false);
    }
  };

  useEffect(()=>{
      getAllPageContent();
  },[hostLanguage])
  return (
    <Formik
      initialValues={{
        companyname: "",
        name: "",
        email: "",
        phonenumber: "",
        message: "",
      }}
      onSubmit={handleSubmit}
      validationSchema={
        hostLanguage === "ch" || hostLanguage === "de" ? schemaGer : schemaEn
      }
    >
      {({ handleChange, handleSubmit, errors, values, touched }) => (
        <>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>
                  {contentDetails?.contact_form?.company_name}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={contentDetails?.contact_form?.company_name_placeholder}
                  name="companyname"
                  onChange={handleChange}
                  value={values.companyname}
                />
                {errors.companyname && touched.companyname && (
                  <div className="error">{errors.companyname}</div>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>
                  {contentDetails?.contact_form?.name}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={contentDetails?.contact_form?.name_placeholder}
                  name="name"
                  onChange={handleChange}
                  value={values.name}
                />
                {errors.name && touched.name && (
                  <div className="error">{errors.name}</div>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>
                  {contentDetails?.contact_form?.e_mail}
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder={contentDetails?.contact_form?.e_mail_placeholder}
                  name="email"
                  onChange={handleChange}
                  value={values.email}
                />
                {errors.email && touched.email && (
                  <div className="error">{errors.email}</div>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>
                  {contentDetails?.contact_form?.telephone_number}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={contentDetails?.contact_form?.telephone_number_placeholder}
                  name="phonenumber"
                  maxLength={20}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, "");
                    handleChange({
                      target: { name: "phonenumber", value: numericValue },
                    });
                  }}
                  value={values.phonenumber}
                />
                {errors.phonenumber && touched.phonenumber && (
                  <div className="error">{errors.phonenumber}</div>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>
                  {contentDetails?.contact_form?.message}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder={contentDetails?.contact_form?.message_placeholder}
                  name="message"
                  onChange={handleChange}
                  value={values.message}
                />
                {errors.message && touched.message && (
                  <div className="error">{errors.message}</div>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="primary"
            type="submit"
            className="BtnSubmit"
            disabled={isSubmit}
            onClick={() => handleSubmit()}
            style={isSubmit ? { cursor: "not-allowed" } : {}}
          >
            {contentDetails?.contact_form?.button_text}
          </Button>
          <Button
            variant="primary"
            type="button"
            className="BtnSubmit whatsapp-btn"
            onClick={() => {
              window.open(
                "https://api.whatsapp.com/message/WMW2NPRW65XDK1",
                "_blank"
              );
            }}
          >
            {contentDetails?.contact_form?.button_whatsapp}
          </Button>
        </>
      )}
    </Formik>
  );
};

export default ContactForm;
